import router from '../../../router/index.js';
import apiClient from '@/api/apiClient.js';
import { getAuthData } from '../../utils/storeHelpers';


export default {
  namespaced: true,
  state: {
    schema: {},
    coModel: {},
    status: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    coModel(state) {
      return state.coModel;
    },
    status(state) {
      return state.status;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertCoModel(state, coModel) {
      state.coModel = coModel;
    },
    saveData(state) {
      state.status = 'success';
    },
    saveError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async loadSchema({ commit, rootState }) {
      try {
        const res = await apiClient.testCOx04Schema();
        const schema = res.data;

        if (rootState.auth.authData.coNew === true) {
          delete schema.coBtnIcons[0].update;
          schema.coBtnIcons[0].btnResults = false;
        } else {
          delete schema.coBtnIcons[0].calification;
          schema.coBtnIcons[0].btnResults = true;
        }
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },

    async loadModelForm({ commit, rootState }) {
      try {
        const res = await apiClient.testCOx04Schema();
        const schemaFormItems = res.data.schemaFormItems;

        if (rootState.auth.authData.coNew === true) {
          let modelForm = [];
          let modelFormVoid = [
            { modelForm: { group1: {}, group2: {}, group3: {} } },
            { modelForm: { group1: {}, group2: {} } },
          ];
          let numObjects = Object.keys(modelFormVoid).length;

          let coBaremo = 1;
          let coDateEva = '';
          let coAgeEva = '---';
          let coInfo = { coBaremo, coDateEva, coAgeEva };

          for (let i = 0; i < numObjects; i++) {
            modelForm[i] = {
              modelForm: modelFormVoid[i].modelForm,
              schemaForm: schemaFormItems[i].schemaForm,
            };
          }

          let coModel = {
            modelForm,
            coInfo,
          };
          commit('insertCoModel', coModel);
        } else {
          const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
          const id = rootState.auth.authData.coNumId;
          const res = await apiClient.modelTestCOx04(id, clinicalHistories_id, institutions_profes_id);
          const data = res.data.data;

          let coBaremo = data.dataCo.co_04_baremo;
          let coDateEva = data.dataCo.co_04_evaluation_date;
          let coAgeYearsEva = data.dataCo.co_04_evaluation_age_years;
          let coAgeMonthsEva = data.dataCo.co_04_evaluation_age_months;
          let coAgeDaysEva = data.dataCo.co_04_evaluation_age_days;
          let coAgeEva = `${coAgeYearsEva} a,  ${coAgeMonthsEva} m,  ${coAgeDaysEva} d`;
          let coInfo = { coBaremo, coDateEva, coAgeEva };

          let dataCoItems = data.dataCoItems;
          let modelForm = [];
          for (let i = 0; i < dataCoItems.length; i++) {
            modelForm[i] = {
              modelForm: dataCoItems[i].modelForm,
              schemaForm: schemaFormItems[i].schemaForm,
            };
          }
          let coModel = {
            modelForm,
            coInfo,
          };
          commit('insertCoModel', coModel);
        }
      } catch (e) {
        console.error(e);
        commit('insertCoModel');
      }
    },

    async save({ commit }, model) {
      try {
        if (model.coNew === true) {
          const res = await apiClient.saveTestCOx04(model);
          let coInfo = res.data.data;
          let coNumId = coInfo.corrector_04_id;
          let coEvaNum = coInfo.co_04_evaluation_number;
          commit('auth/setCoNumId', coNumId, { root: true });
          commit('auth/setCoEvaNum', coEvaNum, { root: true });
          if (res.status === 200) {
            router.push({ name: 'test-result' });
          }
        } else {
          await apiClient.saveTestCOx04(model);
        }
        commit('saveData');
      } catch (e) {
        console.error('Error guardando');
        if (e.response.data.error === 'LLAVECO_NOT_EXIST') {
          alert('Debe adjuntar la llave de los correctores. Ingrese a Co-Llave.');
          router.push({ name: 'list' });
        }
        commit('saveError');
      }
    },
  },
};
